// src/store/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // يستخدم localStorage

// استيراد الـ Reducers الخاصة بك
import formReducer from "./formSlice";
import settingsReducer from "./settingsSlice";
import sessionReducer from "../services/authServices/getSetionService";
import assessmentReducer from "../services/assessmentService";
import studentsReducer from "../services/studentsService";

// 1. إعدادات الحفظ (Persist Configuration)
const persistConfig = {
  key: "root",
  storage,
  // حدد هنا أسماء الـ reducers التي تريد حفظها فقط (نفس الأسماء المستخدمة في combineReducers)
  // إذا أردت حفظ كل شيء، يمكنك حذف سطر الـ whitelist بالكامل
whitelist: [
  "assessment", 
  "form",
   "session", 
   "settings",
    "students"
  ],
};

// 2. تجميع كل الـ Reducers في مكان واحد
const rootReducer = combineReducers({
  session: sessionReducer,
  form: formReducer,
  settings: settingsReducer,
  assessment: assessmentReducer,
  students: studentsReducer,
});

// 3. تغليف الـ rootReducer بـ persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. إنشاء الـ Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // هذا الإعداد ضروري جداً لمنع أخطاء (SerializableStateInvariantMiddleware) في الكونسول
      serializableCheck: {
        ignoredActions: [
          "persist/FLUSH",
          "persist/REHYDRATE",
          "persist/PAUSE",
          "persist/PERSIST",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

// 5. إنشاء وتصدير الـ persistor
export const persistor = persistStore(store);

export default store;